import { ErrorHandler, inject, Injectable, Provider } from '@angular/core';
import { NGX_LOGGER_CONFIG, NGX_LOGGER_LEVELS, NgxLoggerErrorHandler, NgxLoggerService } from '@allianz/ngx-logger';
import { APP_CONFIG, AppConfigModel } from '@retail-portal-santander-frontend/app-config';
import { WINDOW } from '@retail-portal-santander-frontend/shared-utils';

export const provideLogger = (environment: AppConfigModel): Provider[] => {
  if (!environment.production || !environment.loggerUrl) {
    return [];
  }

  return [
    {
      provide: NGX_LOGGER_CONFIG,
      useValue: {
        console: {
          level: NGX_LOGGER_LEVELS.DEBUG,
          appendLevel: true,
          appendTimestamp: true,
        },
        server: {
          level: NGX_LOGGER_LEVELS.DEBUG,
          appName: 'retail-portal-santander-frontend',
          endpoint: environment.loggerUrl,
        },
      },
    },
    {
      provide: NgxLoggerService,
      useClass: CustomLoggerService,
    },
    {
      provide: ErrorHandler,
      useClass: NgxLoggerErrorHandler,
      deps: [NgxLoggerService],
    },
  ];
};

@Injectable()
// @ts-expect-error private method
class CustomLoggerService extends NgxLoggerService {
  private readonly window = inject(WINDOW);
  private readonly appConfig = inject(APP_CONFIG);

  private override logToServer(level: NGX_LOGGER_LEVELS, msg: string, ...params: unknown[]) {
    const additionalInformation: Record<string, unknown> = {
      policyNumber: this.getPolicyNumberFromUrl(),
      version: this.appConfig.version,
    };
    // @ts-expect-error private method
    super.logToServer(level, msg, additionalInformation, ...params);
  }

  private getPolicyNumberFromUrl(): string | null {
    return new URLSearchParams(this.window.location.search).get('policyNumber');
  }
}
